import script from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"

import "./BasicInfo.vue?vue&type=style&index=0&id=ca54a00e&lang=less"
import "./BasicInfo.vue?vue&type=style&index=1&id=ca54a00e&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca54a00e"]])

export default __exports__